import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { RETURN_MOTIFS, REFUSAL_MOTIFS, CREDIT_NOTE, QUESTIONS, ELIGIBLE_CARRIER_TYPES } from '~/const/help';
import ListProductItem from '~/components/organisms/Webform/ListProductItem.vue';
import StepsBreadcrumb from '~/components/atoms/StepsBreadcrumb.vue';
import FormReasonsReturnRefuse from '~/components/organisms/Webform/formReasons/FormReasonsReturnRefuse.vue';
import FormReasonsNotShipped from '~/components/organisms/Webform/formReasons/FormReasonsNotShipped.vue';
import FormSolution from '~/components/organisms/Webform/FormSolution.vue';
import MdmSelect from '~/components/atoms/MdmSelect.vue';
import MdmIcon from '~/components/atoms/Global/MdmIcon';
import MdmLoader from '~/components/atoms/Global/MdmLoader.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-left.svg';
var PRODUCT_NOT_SHIPPED = 'product-not-shipped';
export default {
  name: 'TemplateReturn',
  components: {
    StepsBreadcrumb,
    MdmSelect,
    ListProductItem,
    FormReasonsNotShipped,
    FormReasonsReturnRefuse,
    FormSolution,
    MdmIcon,
    MdmLoader
  },
  props: {
    title: {
      type: String,
      required: true
    },
    orderList: {
      type: Array,
      required: true
    },
    preSelectedBl: {
      type: String,
      default: ''
    },
    pendingRequest: {
      type: Boolean,
      required: true
    },
    templateType: {
      type: String,
      required: true,
      validator: val => ['RETURN', 'REFUSE', 'NOT_SHIPPED'].includes(val)
    }
  },

  data() {
    return {
      stepIndex: 0,
      nbSteps: 4,
      selectedOrder: null,
      selectedBl: null,
      selectedProducts: [],
      selectedReasons: {},
      selectedSolution: '',
      selectedSolutionLabel: '',
      productPhotos: [],
      selectedRefundType: '',
      isSubmitBtnClicked: false
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    isReturnTemplate() {
      return this.templateType === 'RETURN';
    },

    isRefusalTemplate() {
      return this.templateType === 'REFUSE';
    },

    isNotShippedTemplate() {
      return this.templateType === 'NOT_SHIPPED';
    },

    formReasons() {
      return this.isRefusalTemplate ? REFUSAL_MOTIFS : RETURN_MOTIFS;
    },

    isOrderNotEligibleForRefusal() {
      return this.isRefusalTemplate && this.isOrderPaidByCetelem && this.isOrderOfMagType;
    },

    step() {
      return this.stepIndex + 1;
    },

    stepLabel() {
      var titleId = this.step;

      if (this.nbSteps === 3) {
        titleId += 1;
      }

      return this.$t("step.".concat(titleId)) || '';
    },

    stepId() {
      return this.nbSteps - this.stepIndex;
    },

    orders() {
      return this.orderList.map(order => ({
        id: order.reference,
        label: this.$t('order', {
          orderId: order.customerReference,
          date: order.date
        })
      }));
    },

    selectedOrderDetails() {
      return this.orderList.find(orderInfo => orderInfo.reference === this.selectedOrder);
    },

    blList() {
      var order = this.selectedOrderDetails;

      if (order) {
        return order.shipping.expeditions.map(exp => exp.reference);
      }

      return [];
    },

    expeditionDetails() {
      var order = this.selectedOrderDetails;

      if (order && this.selectedBl) {
        return order.shipping.expeditions.find(exp => exp.reference === this.selectedBl);
      }

      return null;
    },

    products() {
      if (this.expeditionDetails) {
        return this.expeditionDetails.items.map(item => _objectSpread(_objectSpread({}, item.product), {}, {
          total: item.total,
          quantity: item.quantity
        }));
      }

      return [];
    },

    channel() {
      return this.selectedOrderDetails && this.selectedOrderDetails.channel === 'WEB' ? 'web' : 'mag';
    },

    isBlDeliveryInProgess() {
      return this.expeditionDetails && this.expeditionDetails.status.name === 'DELIVERY_IN_PROGRESS';
    },

    isBlStatusReturnable() {
      return this.isReturnTemplate && this.isBlDeliveryInProgess;
    },

    isBlReturnable() {
      return this.expeditionDetails && this.expeditionDetails.returnable;
    },

    isFormBtnDisabled() {
      return !this.selectedSolution || this.showMagMsg || this.pendingRequest;
    },

    isDeliveryOfTypeStore() {
      if (this.expeditionDetails && this.expeditionDetails.carrier) {
        var {
          carrier: {
            id
          }
        } = this.expeditionDetails;
        return id === 'MAGASIN';
      }

      return false;
    },

    isUserNotEligibleToReturnProducts() {
      return !this.selectedBl || this.isGoToMagMessageDisplayed;
    },

    isCarrierOfTypeColissimo() {
      if (this.expeditionDetails && this.expeditionDetails.carrier) {
        var {
          carrier: {
            id
          }
        } = this.expeditionDetails;
        return ELIGIBLE_CARRIER_TYPES.includes(id);
      }

      return false;
    },

    isOrderPaidByCetelem() {
      if (this.selectedOrderDetails) {
        var {
          payments
        } = this.selectedOrderDetails;
        return payments.some(e => e.type === 'CETELEM' || e.type === 'CETELEMPRESTO');
      }

      return false;
    },

    isOrderOfMagType() {
      if (this.selectedOrderDetails) {
        var {
          channel
        } = this.selectedOrderDetails;
        return channel === 'STORE';
      }

      return false;
    },

    showMagMsg() {
      var hasContractMessage = this.getReasonConfiguration && this.getReasonConfiguration.creditNoteMag;
      var showMagMsg = hasContractMessage && this.channel === 'mag' && this.selectedSolution === CREDIT_NOTE && this.isOrderPaidByCetelem;
      return showMagMsg;
    },

    getReasonConfiguration() {
      return this.formReasons.label.find((_ref) => {
        var {
          reason
        } = _ref;
        return reason[this.locale.language] === this.selectedReasons.reason;
      });
    },

    getSolutions() {
      if (this.isRefusalTemplate || this.isReturnTemplate) {
        if (this.selectedReasons && this.selectedReasons.reason) {
          var motif = this.getReasonConfiguration;
          return motif.solution && motif.solution[this.channel] || [];
        }

        return [];
      }

      return QUESTIONS[PRODUCT_NOT_SHIPPED].solution[this.channel];
    },

    isGoToMagMessageDisplayed() {
      return this.isOrderNotEligibleForRefusal || this.isReturnTemplate && this.isDeliveryOfTypeStore;
    },

    isSelectedReasonColissimo() {
      if (this.getReasonConfiguration) {
        return !!this.getReasonConfiguration.eligibleColissimo;
      }

      return false;
    }

  }),
  watch: {
    selectedOrder() {
      this.selectedBl = null;

      if (this.preSelectedBl) {
        this.selectedBl = this.preSelectedBl;
      }
    },

    stepIndex() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },

    pendingRequest() {
      if (!this.pendingRequest) {
        this.isSubmitBtnClicked = false;
      }
    }

  },

  created() {
    this.checkPreSelectedBl();
  },

  methods: {
    onSubmit() {
      this.isSubmitBtnClicked = true;

      if (this.isRefusalTemplate || this.isReturnTemplate) {
        this.submitRefuseOrReturnProduct();
      } else {
        this.submitNotShippedProduct();
      }
    },

    submitRefuseOrReturnProduct() {
      var isColissimoEligible = this.isReturnTemplate && this.isColissimoEligible();
      var colissimoInfo = null;

      if (isColissimoEligible) {
        colissimoInfo = {
          refund: this.selectedRefundType,
          isTotalRefund: this.isTotalRefundColissimo(),
          customerOrderId: this.selectedOrderDetails.customerReference
        };
      }

      var productReturn = _objectSpread(_objectSpread({
        order: this.selectedOrder,
        bl: this.selectedBl,
        productReturnItems: this.selectedProducts,
        reasons: this.selectedReasons,
        solution: this.selectedSolution,
        solutionLabel: this.selectedSolutionLabel,
        productPhotos: this.productPhotos,
        isColissimoEligible
      }, colissimoInfo), this.getReasonAndSecondarySegmentation());

      this.$emit('product-return', productReturn);
    },

    submitNotShippedProduct() {
      var productReturn = {
        order: this.selectedOrder,
        bl: this.selectedBl,
        reasons: this.selectedReasons,
        productReturnItems: this.selectedProducts,
        solution: this.selectedSolution,
        solutionLabel: this.selectedSolutionLabel
      };
      this.$emit('product-return', productReturn);
    },

    getReasonAndSecondarySegmentation() {
      var selectedReason = this.getReasonConfiguration;
      var {
        reason,
        secondarySegmentationType,
        secondarySegmentationCode
      } = selectedReason;
      return {
        reasonLabel: reason[this.locale.language],
        secondarySegmentationType,
        secondarySegmentationCode
      };
    },

    previous() {
      this.stepIndex -= 1;
    },

    next() {
      this.stepIndex += 1;
    },

    checkPreSelectedBl() {
      if (this.preSelectedBl) {
        this.selectedOrder = this.orderList[0].reference;
        this.nbSteps = 3;
      }
    },

    updateSelectedProducts(products) {
      this.selectedProducts = products;
    },

    updateReasonsNotShipped(_ref2) {
      var {
        reserve,
        comment
      } = _ref2;
      this.selectedReasons = {
        reserve,
        comment
      };
    },

    updateReasons(_ref3) {
      var {
        reason,
        subReason,
        reserve,
        comment,
        productPhotos
      } = _ref3;
      this.selectedReasons = {
        reason,
        subReason,
        reserve,
        comment
      };
      this.productPhotos = productPhotos;
    },

    updateSolution(data) {
      this.selectedSolution = data.value;
      this.selectedSolutionLabel = data.label;
      this.setRefundTypeForColissimo();
    },

    setRefundTypeForColissimo() {
      this.selectedRefundType = this.selectedSolution === CREDIT_NOTE ? 'CREDIT' : 'REFUND';
    },

    isColissimoEligible() {
      var isBlEligible = this.isBlReturnable && this.isCarrierOfTypeColissimo; // TODO BL must not contain mirakl items;

      var isOrderEligible = this.selectedOrderDetails.orderSource === 'MERCURE';

      if (isBlEligible && isOrderEligible && this.isSelectedReasonColissimo) {
        var areProductsQtyEligible = this.selectedProductsQuantityDetails().map(this.getProductQuantityEligibleColissimo).every(notZeroQuantity => notZeroQuantity);
        return areProductsQtyEligible;
      }

      return false;
    },

    selectedProductsQuantityDetails() {
      return this.selectedProducts.map(product => {
        var selectedProductDetails = this.expeditionDetails.items.find(item => item.product.reference === product.productId) || {};
        var {
          quantity,
          returnedQuantity
        } = selectedProductDetails;
        return {
          quantity,
          returnedQuantity,
          selectedQuantity: product.quantity
        };
      });
    },

    getProductQuantityEligibleColissimo(_ref4) {
      var {
        quantity,
        returnedQuantity,
        selectedQuantity
      } = _ref4;
      var eligibleQty = quantity - returnedQuantity;

      if (!eligibleQty || eligibleQty < 0 || selectedQuantity > eligibleQty) {
        return 0;
      }

      return selectedQuantity;
    },

    isTotalRefundColissimo() {
      return this.expeditionDetails.items.map((_ref5) => {
        var {
          product,
          quantity,
          returnedQuantity
        } = _ref5;
        var selectedQuantity = 0;
        var selectedItem = this.selectedProducts.find(selectedProduct => selectedProduct.productId === product.reference);

        if (selectedItem) {
          selectedQuantity = selectedItem.quantity;
        }

        return {
          reference: product.reference,
          quantity,
          returnedQuantity,
          selectedQuantity
        };
      }).every(product => product.returnedQuantity + product.selectedQuantity === product.quantity);
    }

  }
};